import { ImageProps } from 'next/legacy/image'
import React, { PropsWithChildren, ReactElement } from 'react'
import { Flex, chakra, useSlotRecipe } from '@chakra-ui/react'
import Image from '@reward-platform/lift/components/ChakraNextImage'

interface ImageCardProps extends PropsWithChildren<ImageProps> {
  href?: string
  imagePosition?: 'top' | 'bottom'
}

type ImageCardCaptionProps = PropsWithChildren<{
  heading?: string
  subHeading?: string
  headerItem?: React.ReactNode
}>

function ImageCard({
  children,
  href,
  imagePosition = 'top',
  ...props
}: Readonly<ImageCardProps>): ReactElement<React.PropsWithChildren> {
  const recipe = useSlotRecipe({ key: 'imageCard' })
  const styles = recipe({})

  return (
    <chakra.figure css={styles.figure}>
      {imagePosition === 'top' && <Image {...props} />}
      <chakra.figcaption css={styles.figcaption}>{children}</chakra.figcaption>
      {imagePosition === 'bottom' && <Image {...props} />}
    </chakra.figure>
  )
}

function ImageCardCaption({
  children,
  heading,
  subHeading,
  headerItem,
}: Readonly<ImageCardCaptionProps>): ReactElement<React.PropsWithChildren> {
  const recipe = useSlotRecipe({ key: 'imageCard' })
  const styles = recipe({})
  const HeaderWrapper = headerItem ? Flex : React.Fragment
  return (
    <>
      {heading ? (
        <HeaderWrapper justifyContent="space-between">
          <chakra.h3 css={styles.heading}>{heading}</chakra.h3>
          {headerItem ?? null}
        </HeaderWrapper>
      ) : null}
      {subHeading ? <chakra.h4 css={styles.subHeading}>{subHeading}</chakra.h4> : null}
      {children ? <chakra.p css={styles.caption}>{children}</chakra.p> : null}
    </>
  )
}

ImageCard.Caption = ImageCardCaption

export default ImageCard
